/**
 * 生成uuid方法
 * @returns {string}
 */
export const createUUID = function (){
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

/**
 * 深拷贝
 * @param {*} obj 拷贝对象(object or array)
 * @param {*} cache 缓存数组
 */
export const deepClone = function  (obj, cache = []) {
  // typeof [] => 'object'
  // typeof {} => 'object'
  if (obj === null || typeof obj !== 'object') {
    return obj
  }
  // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
  /**
	 * 类似下面这种
	 * var a = {b:1}
	 * a.c = a
	 * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
	 */
  const hit = cache.filter(c => c.original === obj)[0]
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ?  [] :   {}
  // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
  cache.push({
    original: obj,
    copy,
  })
  Object.keys(obj).forEach(key => {
    copy[key] = deepClone(obj[key], cache)
  })

  return copy
}

export const plugins = {
  table: 'DTable',
  report: 'DChart',
  manageTable: 'DManageTable',
  calendar: 'DCalendar',
  gantt: 'DGantt',
  image: 'QkImage',
  text: 'DText',
  filter: 'DFilter',
  filterBtn: 'DFilterBtn',
}

export const menus = [{
  label: '图表',
  items: [
    {
      label: '统计表',
      icon: 'bi-clipboard-data',
      type: 'report',
    },
    {
      label: '明细表',
      icon: 'bi-table',
      type: 'table',
      enabled: true,
    },
    {
      label: '数据管理表',
      icon: 'bi-kanban',
      type: 'table',
    },
    {
      label: '日历',
      icon: 'bi-calendar',
      type: 'table',
    },

    {
      label: '甘特图',
      icon: 'bi-bar-chart-steps',
      type: 'table',
    },
  ],
},
{
  label: '组件',
  items: [
    {
      label: '图片组件',
      icon: 'bi-clipboard-data',
      type: 'image',
    },
    {
      label: '文本组件',
      icon: 'bi-input-cursor-text',
      type: 'image',
    },
    {
      label: '筛选组件',
      icon: 'bi-filter',
      type: 'image',
    },
    {
      label: '筛选按钮',
      icon: 'bi-filter-square',
      type: 'image',
    },
  ],
},
]
